<template>
  <div id="app">  
    <Banner v-if="route != '/'"/>
    <router-view/>
    <Help v-if="loggedIn" />
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { computed } from 'vue';
import Banner from './components/Banner'
import Help from './components/Help.vue';

export default {
  name: 'App',
  components: {
    Banner,
    Help 
  },
  setup() {
    const store = useStore();
    const route = computed(() => store.state.route)
    const loggedIn = computed(() => store.state.loggedIn)

    return {
      route,
      loggedIn
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  position: relative;
  height: 100%;
}
</style>
